import { z } from 'zod';
import { strictRemoteCodec } from "./remote-codec.js";
import { CopilotAccountIdSchema, CopilotAccountsViewSchema } from "./copilot-accounts-remote.js";
import { CopilotUsageViewSchema } from "./copilot-usage-remote.js";
export const SessionAccountViewSchema = z.object({
    source: z.enum(['global', 'session']),
    accountId: CopilotAccountIdSchema,
    globalAccountId: CopilotAccountIdSchema,
    runningAccountId: CopilotAccountIdSchema.optional(),
    accounts: CopilotAccountsViewSchema,
}).strict().refine(view => view.accountId === view.accounts.activeAccountId, { message: 'Session account identity mismatch' });
export const TurnAccountViewSchema = z.discriminatedUnion('state', [
    z.object({ state: z.literal('unknown') }).strict(),
    z.object({ state: z.literal('recorded'), accountId: CopilotAccountIdSchema,
        source: z.enum(['global', 'session']),
        identity: CopilotAccountsViewSchema.shape.accounts.element.shape.identity }).strict(),
]);
const agent = { name: 'agent', wire: 'agentId', source: 'lookup', lookup: 'agent',
    codec: strictRemoteCodec('@deepseek-ai/dsh-session/types#SessionId', z.string().min(1).max(256)) };
const contribution = {
    package: 'dsh-github-copilot',
    descriptors: ['get', 'set', 'refreshIdentity', 'ensureIdentity', 'usage', 'refreshUsage', 'turn'].map(method => ({
        id: `dsh-github-copilot:githubCopilotSessionAccount.${method}`,
        namespace: 'githubCopilotSessionAccount', service: 'githubCopilotSessionAccount', method,
        invocation: { kind: 'direct' },
        parameters: [agent, ...(method === 'set' ? [
                { name: 'accountId', wire: 'accountId', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#SessionAccountChoice', CopilotAccountIdSchema.nullable()) },
                { name: 'revision', wire: 'revision', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#SessionAccountRevision', z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER)) },
            ] : method === 'turn' ? [
                { name: 'turn', wire: 'turn', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#SessionAccountTurn', z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER)) },
            ] : [])],
        result: method === 'usage' || method === 'refreshUsage'
            ? strictRemoteCodec('dsh-github-copilot#CopilotUsageView', CopilotUsageViewSchema)
            : method === 'turn' ? strictRemoteCodec('dsh-github-copilot#TurnAccountView', TurnAccountViewSchema)
                : strictRemoteCodec('dsh-github-copilot#SessionAccountView', SessionAccountViewSchema),
    })),
};
export default contribution;
//# sourceMappingURL=session-accounts-remote.js.map